import { fourPlaceHolder } from "modules/utilities/utility";
import React from "react";
import {Tooltip } from "antd";
import NoData from "assets/svgs/no_data/NoData";
import moment from "moment";
import { Link } from "react-router-dom";

function FemaleSurveyTable({ femaleFeedback, isLoading }) {
  return (
    <div>
      <div className="mt-2">
        <div className="mt-1 shadow">
          <div className="d-flex border rounded-top table-head">
            <span className="p-2 fw-bold text-black flex-1">Customer Name</span>
            <span className="p-2 fw-bold text-black flex-1">Hair Problem</span>
            <span className="p-2 fw-bold text-black flex-1">
              Traya Conditioner
            </span>
            <span className="p-2 fw-bold text-black flex-1">Satisfaction</span>
            <Tooltip placement="top" title="Reasonable Price Range">
              <span className="p-2 fw-bold text-black flex-1 text-truncate">
                Reasonable Price Range
              </span>
            </Tooltip>
            <span className="p-2 fw-bold text-black flex-1">
              Current Conditioner
            </span>
            <span className="p-2 fw-bold text-black flex-1">
              Additional Comment
            </span>
            <span className="p-2 fw-bold text-black flex-1">Created At</span>
          </div>
          {isLoading ? (
            fourPlaceHolder()
          ) : femaleFeedback?.length ? (
            femaleFeedback?.map((female, index) => {
              let hearData = "";
              female?.hair_problem?.forEach((item) => {
                hearData += item;
              });
              return (
                <div
                  className={`d-flex table-row border border-top-0 ${
                    index === female?.length - 1 && "rounded-bottom"
                  }`}
                >
                  <span className="flex-1 d-flex flex-column gap-1 p-2 fw-bold">
                    <Link to={`/lead-details/${female?.user?.caseId}`}>
                      <div className="fw-bold text-primary">
                        {" "}
                        {female?.user?.first_name}
                      </div>
                    </Link>
                  </span>
                  <Tooltip placement="top" title={hearData}>
                    <span className="flex-1 text-black p-2 text-truncate">
                      {hearData}
                    </span>
                  </Tooltip>
                  <span className="flex-1 text-black p-2">
                    {female?.traya_conditioner ? "Yes" : "No"}
                  </span>
                  <span className="flex-1 text-black p-2">
                    {female?.satisfaction}
                  </span>
                  <span className="flex-1 text-black p-2">
                    {female?.reasonable_price_range}
                  </span>
                  <Tooltip placement="top" title={female?.current_conditioner}>
                    <span className="flex-1 text-black p-2 text-truncate">
                      {female?.current_conditioner}
                    </span>
                  </Tooltip>
                  <span className="flex-1 text-black p-2">
                    {female?.additional_comments}
                  </span>
                  <span className="flex-1 text-black p-2">
                    {moment(female.createdAt).format("DD/MM/YY HH:mm:ss")}
                  </span>
                </div>
              );
            })
          ) : (
            <div className="p-3 rounded-bottom bg-white text-center">
              No Data Available <NoData />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default FemaleSurveyTable;
